module.exports = __webpack_public_path__ + "static/media/icon-checked.f0c251f1.svg";